<template>
  <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
    <div class="justify-content-start d-flex">
      <h3><strong class="text-primary">Colaboradores</strong></h3>
    </div>
    
    <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
      <search-input-component :search="search" @onSearch="handleSearch"></search-input-component>
      <StudentActions 
        :download-url="downloadUrl"
        @disable-users="$emit('disable-users')"
        @bulk-upload="$emit('bulk-upload')"
        @add-user="$emit('add-user')"
      />
    </div>
  </div>
</template>

<script>
import StudentActions from './StudentActions.vue'

export default {
  name: 'StudentFilters',
  
  components: {
    StudentActions
  },
  
  props: {
    search: { type: String, default: '' },
    downloadUrl: { type: String, required: true }
  },
  
  emits: ['search', 'disable-users', 'bulk-upload', 'add-user'],
  
  methods: {
    handleSearch(searchText) {
      this.$emit('search', searchText)
    }
  }
}
</script>

<style scoped>
.text-primary {
  color: #1A0054 !important;
}
</style>